import React, { useState, useEffect } from 'react';
import { formatDate } from '../utils';
import { useResponsive } from '../../hooks/useResponsive';

interface Props {
  selStart: Date | null;
  selEnd: Date | null;
  editData?: { start: string; end: string; reason: string } | null;
  onSave: (start: string, end: string, reason: string) => void;
  onClose: () => void;
}

export default function BlockModal({ selStart, selEnd, editData, onSave, onClose }: Props) {
  const { isMobile } = useResponsive();
  const [reason, setReason] = useState('');
  const [start, setStart] = useState('');
  const [end, setEnd] = useState('');

  useEffect(() => {
    if (editData) {
      setStart(editData.start);
      setEnd(editData.end);
      setReason(editData.reason);
    } else {
      setStart(selStart ? formatDate(selStart) : '');
      setEnd(selEnd ? formatDate(selEnd) : '');
    }
  }, [editData, selStart, selEnd]);

  const days = start && end ? Math.round((new Date(end + 'T00:00:00').getTime() - new Date(start + 'T00:00:00').getTime()) / 86400000) + 1 : 0;

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.3)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={{ background: 'white', borderRadius: 8, padding: isMobile ? 18 : 20, width: isMobile ? 'calc(100vw - 24px)' : 360, maxWidth: 360 }} onMouseDown={(e) => e.stopPropagation()} onClick={(e) => e.stopPropagation()}>
        <h3 style={{ margin: '0 0 16px', fontSize: 16 }}>{editData ? '예약불가 수정' : '예약불가 설정'}</h3>
        <div style={{ marginBottom: 8, fontSize: 13, color: '#666' }}>
          {start} ~ {end} ({days}일)
        </div>
        <div style={{ marginBottom: 12 }}>
          <label style={{ fontSize: 12, fontWeight: 500, display: 'block', marginBottom: 4 }}>사유</label>
          <input
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder={`${days}일 예약 불가 기간`}
            style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: 4, fontSize: 13 }}
          />
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button
            onClick={() => onSave(start, end, reason || `${days}일 - 예약 불가 기간`)}
            style={{ flex: 1, padding: 10, background: '#1976d2', color: 'white', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 14 }}
          >
            확인
          </button>
          <button onClick={onClose} style={{ flex: 1, padding: 10, background: 'white', color: '#333', border: '1px solid #ccc', borderRadius: 4, cursor: 'pointer', fontSize: 14 }}>취소</button>
        </div>
      </div>
    </div>
  );
}
